import React, { useState } from "react";
import "./forgotPassword.css";
import { forgotPassword } from "../../../services/authAPI";

interface ForgotPasswordProps {
  setDialogView: React.Dispatch<React.SetStateAction<"signin" | "forgot" | "otp" | "reset">>;
  setResetEmail: React.Dispatch<React.SetStateAction<string>>;
}

const ForgotPassword = ({ setDialogView, setResetEmail }: ForgotPasswordProps) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSendOtp = async () => {
    setError(null);

    if (!email.trim()) {
      setError("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setError("Enter a valid email address");
      return;
    }

    try {
      setLoading(true);
      await forgotPassword(email.trim());
      setResetEmail(email.trim());
      setDialogView("otp");
    } catch (err: any) {
      setError(err.message || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='page-wrapper'>
      <main className='main-content'>
        <div className='login-card'>
          {/* Left Panel */}
          <div className='left-panel'>
            <div className='left-panel-content'>
              <h2 className='welcome-title'>
                Forgot Password <span className='heart-icon'>🔐</span>
              </h2>
              <p className='welcome-subtitle'>
                Enter your registered email and we'll send you an OTP to reset your password.
              </p>
            </div>
          </div>

          {/* Right Panel */}
          <div className='right-panel'>
            <h1 className='login-heading'>Forgot Password</h1>
            <p className='login-subheading'>Reset your password using email OTP</p>

            <div className='login-form'>
              {/* Email */}
              <div className='form-group'>
                <label className='form-label'>Email</label>
                <input
                  type='email'
                  className={`form-input${error ? " input-error" : ""}`}
                  placeholder='Enter registered email'
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError(null);
                  }}
                  disabled={loading}
                />
                {error && <span className='field-error-msg'>{error}</span>}
              </div>

              {/* Send OTP button */}
              <button className={`login-btn${loading ? " loading" : ""}`} onClick={handleSendOtp} disabled={loading}>
                {loading ? <span className='spinner' /> : <>Send OTP</>}
              </button>

              {/* Back to Login */}
              <p className='register-prompt'>
                Remember your password?{" "}
                <a
                  href='#'
                  className='register-link'
                  onClick={(e) => {
                    e.preventDefault();
                    setDialogView("signin");
                  }}
                >
                  Back to Login
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ForgotPassword;
